import React from "react";
import RouterProvider from "./providers/RouterProvider";
import "./App.css";

const App = () => {
  return <RouterProvider />;
};

export default App;
